import { render, staticRenderFns } from "./WebsitesList.vue?vue&type=template&id=96f651e6&scoped=true&"
import script from "./WebsitesList.vue?vue&type=script&lang=js&"
export * from "./WebsitesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f651e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f651e6')) {
      api.createRecord('96f651e6', component.options)
    } else {
      api.reload('96f651e6', component.options)
    }
    module.hot.accept("./WebsitesList.vue?vue&type=template&id=96f651e6&scoped=true&", function () {
      api.rerender('96f651e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Websites/WebsitesList.vue"
export default component.exports